import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import AxiosCustom from "common/components/apiConfig";
import {
  handleNotificationAlertCatch,
  handleNotificationAlertTrySelect,
} from "common/method/handleNotificationAlert";

// import { handleNotificationAlertTrySelect } from './../../common/method/handleNotificationAlert/index';

export const actionTypes = {
  selectStaticThresholds: "selectStaticThresholds [Action]",
  selectStaticThresholdsLoading: "selectStaticThresholdsLoading [Action]",
  selectStaticThresholdsAsync: "selectStaticThresholdsAsync [Action]",
};
const inistiaState = {
  data: [],
  loading: false,
  total: 0,
};

export const select_static_thresholds_Reducer = (
  state = inistiaState,
  { type, payload }
) => {
  switch (type) {
    case actionTypes.selectStaticThresholds:
      return {
        ...state,
        data: payload?.results,
        total: payload?.total,
      };
    case actionTypes.selectStaticThresholdsLoading:
      return {
        ...state,
        loading: payload,
      };
    default:
      return state;
  }
};

function* handleWorker({ payload }) {
  yield put({
    type: actionTypes.selectStaticThresholdsLoading,
    payload: true,
  });

  let config = {
    url: "select_request",
  };

  let data = {
    table: "stock",
    method_type: "select_static_thresholds",
    data: payload?.data ? payload.data : {},
  };

  try {
    let res = yield AxiosCustom(config, data);
    let isOk = handleNotificationAlertTrySelect(res);
    if (!isOk) {
      return;
    }
    yield put({
      type: actionTypes.selectStaticThresholds,
      payload: res?.data?.response?.data,
    });
  } catch {
    handleNotificationAlertCatch();
  } finally {
    yield put({
      type: actionTypes.selectStaticThresholdsLoading,
      payload: false,
    });
  }
}

export function* selectStaticThresholds() {
  yield takeLatest(actionTypes.selectStaticThresholdsAsync, handleWorker);
}
